<!--
* 组件名 : 迫害情况（不完全统计）
* 开发者 : HN
*
* 参数:
*  title            { string }    - 阶段标题
*  statisticsList   { Array }     - 迫害分类数据
*  totalNum         { string }    - 被迫害致死人数
*
* 事件:  null
*
*
-->
<template>
  <div class="persecution-situation">
    <h2 v-html="title" class="coerce-title title1"></h2>
    <div class="ps-list" ref="psList">
      <div class="item" v-for="(item, index) in statisticsList" :key="index">
        <p class="item-title" v-html="item.title"></p>
        <div
          class="icon-box"
          v-bg-img="`images/spread-of-kingdom-gospel/2012/${item.type}.svg`"
        />
        <b class="num" :id="'num' + (index + 1)">{{ item.num }}</b>
      </div>
    </div>
    <h3 class="total-num" v-html="totalNum"></h3>
  </div>
</template>

<script>
import debounce from "debounce";
import { CountUp } from "@/vendor/countUp.min";
export default {
  name: "persecution-situation",
  props: {
    statisticsList: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    totalNum: {
      type: String,
      default: "",
    },
  },
  created() {
    this.start_move = debounce(this.set_count_up);
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener("scroll", this.start_move);
    }, 100);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.start_move);
  },
  methods: {
    /**
     * 迫害分类数据里数字滚动效果
     */
    set_count_up() {
      if (
        $("html, body").scrollTop() + window.innerHeight <
          $(".ps-list .icon-box")
            .eq(0)
            .offset().top ||
        $(".persecution-situation").length === 0
      )
        return;

      if (this.$refs.psList.classList.value.includes("hasCountUp")) return;

      this.$refs.psList.classList.add("hasCountUp");

      let $num = $(".persecution-situation .num");

      this.statisticsList.map((item, index) => {
        if (this.$P.my || this.$P.ne) return;
        if (
          this.$route.path === "/spread-of-kingdom-gospel/2006-2013" &&
          index > 2
        )
          return;

        new CountUp(
          `num${index + 1}`,
          this.replace_separator($num.eq(index).text()),
          {
            startVal: this.replace_separator($num.eq(index).text()) - 30,
            duration: 3.6,
            easingFn: (t, b, c, d) => {
              let ts = (t /= d) * t;
              let tc = ts * t;
              return b + c * (tc + -3 * ts + 3 * t);
            },
          }
        ).start();
      });
    },
    /**
     * 过滤掉原始字符串中的分隔符( , )
     */
    replace_separator(str) {
      return parseInt(str.replace(/,/, ""));
    },
  },
};
</script>

<style lang="scss">
.persecution-situation {
  padding-top: 170px;

  .coerce-title.title1 {
    text-align: center;
    margin: 0 auto 72px auto;
    color: $color-white;
    max-width: 1084px;
  }

  .ps-list {
    display: flex;
    justify-content: center;
    margin-bottom: 144px;

    .item {
      background: rgba(#152f65, 0.66);
      border: 1px solid rgba(#152f65, 0.8);
      box-sizing: border-box;
      width: 360px;
      height: 338px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      color: $color-white;
      margin: 0 12px;
      padding: 38px;
    }
    .item-title {
      font-size: 20px;
      line-height: 1.3;
      text-align: center;
      width: 100%;
    }
    .icon-box {
      width: 60px;
      height: 50px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

    .num {
      font-family: $num-font;
      font-size: 58px;
      color: #f0bb44;
      letter-spacing: 3px;
    }
  }

  .total-num {
    font-size: 34px;
    text-align: center;
    margin-bottom: 24px;
    color: $color-white;

    mark {
      font-family: $num-font;
      font-size: 67px;
      color: #f0bb44;
      letter-spacing: 3px;
      background-color: inherit;
      margin-left: 16px;
    }
  }
}

@media (max-width: $lx-min) {
  .persecution-situation {
    .ps-list {
      flex-wrap: wrap;
      margin: 0 200px 80px 200px;

      .item {
        width: 424px;
        height: 239px;
        margin: 0 8px 24px 8px;
        padding: 24px;
        .item-title {
          font-size: 16px;
          line-height: 2;
        }
        .num {
          font-size: 40px;
          line-height: 1.8;
        }
      }
    }
    .total-num {
      font-size: 24px;
      mark {
        font-size: 40px;
      }
    }
  }
}

body.latin {
  .persecution-situation {
    .coerce-title {
      font-size: 30px;
    }

    .total-num {
      font-size: 30px;

      mark {
        font-size: 58px;
      }
    }
  }

  &[data-slug="2006-2013"] {
    .ps-list #num4 {
      font-size: 30px;
    }
  }
}
</style>
